import React, { Component, Fragment } from "react";
import SelectMes from "../../Relatorio/Grafico/Radio";
import MultiSelect from "./MultiSelect";
import MetricaSelect from "../MetricaSelect";
import { UNIDADES_ATIVAS } from "../../../../constants/unidades";
import tiposFinanciamento from "../../../../constants/tiposFinanciamento";

// Mesma lista hoje usada em Relatorio/Cursos/SelectCampo (sem constante
// centralizada pra modalidade ainda — não fazia parte do item 8).
const MODALIDADES = [
    "Iniciação Profissional à Distância",
    "Iniciação Profissional Presencial",
    "Qualificação Profissional Presencial",
    "Qualificação Profissional a Distância",
    "Qualificação Profissional - Itinerário V Ensino Médio",
    "Aperfeiçoamento/Espec.Profis.a Distância",
    "Aperfeiçoamento/Espec.Profiss.Presencial",
    "Técnico de Nível Médio Presencial",
    "Técnico de Nível Médio a Distância",
    "Técnico N.Médio Presencial Itinerário V",
    "Aprendizagem Industrial Presencial",
    "Aprendizagem Industrial a Distância",
    "Aprendizagem Industrial Técnica Presenc.",
    "Graduação Tecnológica Presencial",
    'Pós-Graduação "lato sensu" - Especializa',
    "Cursos de Extensão Presencial",
    "Cursos de Extensão a Distância",
];

const OPCOES_UNIDADE = UNIDADES_ATIVAS.map((u) => ({ value: u.nome, label: u.labelRelatorio }));
const OPCOES_TIPO = tiposFinanciamento.LABELS.map((label) => ({ value: label, label }));
const OPCOES_MODALIDADE = MODALIDADES.map((modalidade) => ({ value: modalidade, label: modalidade }));

export default class FiltroBar extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-4">
                        <MultiSelect
                            label="Unidade"
                            opcoes={OPCOES_UNIDADE}
                            selecionados={this.props.unidade}
                            onChange={this.props.selectUnidade}
                            idComponente="selectUnidadeDashboardConsolidado"
                        />
                    </div>
                    <div className="col-md-4">
                        <SelectMes selectMes={this.props.selectMes} mes={this.props.mes} />
                    </div>
                    <div className="col-md-4">
                        <MultiSelect
                            label="Tipo"
                            opcoes={OPCOES_TIPO}
                            selecionados={this.props.tipo}
                            onChange={this.props.selectTipo}
                            idComponente="selectTipoDashboardConsolidado"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <MultiSelect
                            label="Modalidade"
                            opcoes={OPCOES_MODALIDADE}
                            selecionados={this.props.modalidade}
                            onChange={this.props.selectModalidade}
                            idComponente="selectModalidadeDashboardConsolidado"
                        />
                    </div>
                    <div className="col-md-6">
                        <MetricaSelect selectMetrica={this.props.selectMetrica} campo={this.props.campo} idComponente="selectMetricaDashboardConsolidado" />
                    </div>
                </div>
            </Fragment>
        )
    }
}
